import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useForgotPasswordService } from 'services/useAuthService'
import { ToastContext } from 'contexts'
import { useModal } from 'hooks'
import { useNavigate } from 'react-router-dom'

const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Please enter Email address.'),
})

const initialValues = {
    email: '',
}

const useForgotPassword = () => {
    const { t } = useTranslation()
    const { openModal } = useModal()
    const navigate = useNavigate()
    const { forgotPassword, loading: forgotPasswordLoading } = useForgotPasswordService()

    const { setToast } = useContext(ToastContext)

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema,
        onSubmit: async values => {
            const response = await forgotPassword(values.email, () => {})

            if (!response) {
                setToast({
                    message: t('incorrect-email'),
                    type: 'negative',
                    open: true,
                })
                return
            }

            setToast({
                message: t('forget-password-message'),
                type: 'positive',
                open: true,
            })
            navigate('/login')
            openModal({ name: 'email-sent' })
        },
    })

    return {
        formik,
        forgotPasswordLoading,
    }
}

export default useForgotPassword
